<template>
	<sf-data-table
		ref="dataTable"
		:pageUnit="pagingInfo.pageUnit"
		:totalSize="pagingInfo.totalSize"
		paging
		:columns="columns"
		:rows="rows"
		:excel="isButton_(scrId, 'EX')"
		:customExcel="excelFunc"
		@changedPage="changedPage"
	>
		<template v-slot:customRows="slotProps">
			<template v-if="slotProps.column.property === 'pmcId'">
				<span class="highlighted" @click="() => openPopup(slotProps.row)">{{ slotProps.row.pmcId }}</span>
			</template>
			<template v-if="slotProps.column.property === 'wrntStrtDdManual'">
				<span >{{ slotProps.row.wrntStrtDdManual === '1' ? 'Y' : 'N' }}</span>
			</template>
		</template>
	</sf-data-table>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import { BASE_URL } from '@/constants';

export default {
	props: { scrId: { type: String, default: '' } },
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.mainResultList;
		},
		columns() {
			return this.getColumns_;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		openPopup(row) {
			this.$emit('openPopup', row);
		},
		excelFunc() {
			//커스텀 엑셀다운로드시 필요한 함수
			let queryStr = '';

			let strtMm01, endMm01;

			if (this.searchParams.strtMm01) {
				strtMm01 = this.$moment(this.searchParams.strtMm01).format('YYYYMMDD');
			} else {
				strtMm01 = '';
			}
			if (this.searchParams.endMm01) {
				endMm01 = this.$moment(this.searchParams.endMm01).format('YYYYMMDD');
			} else {
				endMm01 = '';
			}

			queryStr = objectToQuerystring({
				srchMm03: this.searchParams.srchMm03, //srchMm03
				strtMm01: strtMm01, //strtMm01
				endMm01: endMm01, //endMm01
				pmcId: this.searchParams.pmcId,
				carVin: this.searchParams.carVin,
				cpnyNm: this.searchParams.cpnyNm,
				licensePlate: this.searchParams.licensePlate,
				lastYn: this.searchParams.lastYn,

			});
			//console.log(' 되냐', queryStr);

			const url = `${BASE_URL}/mqy/qlty/carSaleMst/v1/carSaleMsts/excel` + queryStr;

			const params = { url, columns: this.getColumns_ };
			this.$sf_xlsxDown(params).catch(error => {
				this.$sf_toast({ type: 'error', message: error.message });
			});
		},
		
		async changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('Refresh');
		}
	}
};
</script>

<style></style>
